var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M566.5 49.5H209V538.5H663V419.5H566.5V49.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M822.5 470H663V419.5H566.5V49.5H822.5V470Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1077 49.5H822.5V470H864.5V482H1008V419.5H1077V49.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1035 482H1008V419.5H1077V49.5H1348.5V153.5H1327V537.5H1035V482Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M1666.5 537.5H1327V153.5H1348.5V93.5H1593V419.5H1666.5V537.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1732.5 488H1666.5V419.5H1593V93.5H1838V144.5H1859V513H1732.5V488Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M1933 513H1859V144.5H1838V68H2106V125H2113V422.5H1998.5V487H1933V513Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M1998.5 538.5V487V422.5H2113V125H2106V68H2375V235H2426V346.5H2476V538.5H1998.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M1998.5 626V538.5H2476V730.5H2426V842H2375V1031H2105V965H2114V677.5H2007V626H1998.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 14,
    d: "M1837 1031H2105V965H2114V677.5H2007V626H1998.5V593H1840.5V665H1859V922H1837V1031Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1666.5 674V537.5H1327V1028.5H1603.5V674H1666.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1069 1028.5H1327V537.5H1035V603.5H1007V672H1069V1028.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M209 939V538.5H663V656H567V1028.5H297.5V939H209Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M836 1028.5H567V656H663V593.5H814.5V922.5H836V1028.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2500,
    height: 1270,
    fill: "#D9D9D9",
    fillOpacity: 0.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor2);
export default __webpack_public_path__ + "static/media/select-floor-2.b5e079de.svg";
export { ForwardRef as ReactComponent };